var _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgInnerHeroClipPath(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 0,
    height: 0
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "inner-hero-clip-path_svg__innerHero",
    clipPathUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.32 0h.7v1.03h-.7C.14 1.03 0 .8 0 .52S.14.01.27 0z",
    fill: "none"
  })))));
}

export default SvgInnerHeroClipPath;